import {
  type AdminUserContract,
  createDefaultAdminUser,
  defaultAdminPermissions,
} from '@/contracts/admin-users'
import { createSyntheticMeta } from '@/contracts/questionnaire'
import { requestApiEnvelope } from './http'
import { isApiDataClientMode } from './mode'

export function createInternalAdminProfile(): AdminUserContract {
  return {
    ...createDefaultAdminUser({
      id: 'internal-admin',
      email: 'admin@miao-form.case4.app',
      displayName: '內部管理員',
      legalName: '內部管理員',
      jobTitle: '內部管理員',
      department: '內部管理',
      employeeId: 'INTERNAL_ADMIN',
      company: 'MiaoForm Internal Workspace',
      status: 'active',
      role: 'admin',
      accessScope: 'workspace',
      workspaceRole: 'Internal Admin',
      authProvider: 'manual_invite',
      loginEmailVerified: true,
      allowEmailLogin: true,
      allowGoogleLogin: false,
      permissions: {
        ...defaultAdminPermissions,
        manageAdmins: true,
        manageIntegrations: true,
        manageBranding: true,
        useAiTools: true,
        manageWebhooks: true,
        exportResponses: true,
      },
      auditNotes:
        '內部一般管理員身份；登入帳號與密碼只能由 INTERNAL_ADMIN_ACCOUNT / INTERNAL_ADMIN_PASSWORD 設定。',
      internalNotes: '固定內部管理員清單資訊；密碼不會保存到 D1。',
      createdAt: '2026-06-02',
      updatedAt: '2026-06-02',
    }),
    sourceMeta: createSyntheticMeta(),
  }
}

export function createDraftAdminProfile(): AdminUserContract {
  return {
    ...createInternalAdminProfile(),
    id: '',
    email: '',
    displayName: '',
    legalName: '',
    jobTitle: '',
    department: '',
    employeeId: '',
    phone: '',
    backupEmail: '',
    role: 'admin',
    authProvider: 'google',
    loginEmailVerified: false,
    allowEmailLogin: false,
    allowGoogleLogin: true,
    permissions: {
      ...defaultAdminPermissions,
      manageAdmins: true,
    },
    auditNotes: '',
    internalNotes: '',
    createdAt: '',
    updatedAt: '',
  }
}

export async function listAdminUsers(): Promise<{
  data: AdminUserContract[]
  meta?: Record<string, unknown>
}> {
  if (!isApiDataClientMode()) {
    return {
      data: [createInternalAdminProfile()],
      meta: { source: 'synthetic', total: 1 },
    }
  }
  const envelope = await requestApiEnvelope<AdminUserContract[]>('/api/admin-users')
  return { data: envelope.data, meta: envelope.meta }
}

export async function saveAdminUserToApi(
  admin: AdminUserContract & { password?: string; removePassword?: boolean },
): Promise<AdminUserContract> {
  if (!isApiDataClientMode()) {
    return {
      ...admin,
      id: admin.id || `admin-${crypto.randomUUID()}`,
      updatedAt: new Date().toISOString().slice(0, 10),
      sourceMeta: createSyntheticMeta(),
    }
  }

  const isExistingD1User =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(admin.id)
  const envelope = await requestApiEnvelope<AdminUserContract>(
    isExistingD1User ? `/api/admin-users/${admin.id}` : '/api/admin-users',
    {
      method: isExistingD1User ? 'PATCH' : 'POST',
      body: JSON.stringify(admin),
    },
  )
  return envelope.data
}
